import * as React from 'react';

import { IInfrastructureData, TFutureRoad, TRegularInfrastructureType } from '../../../types/map';
import { getInfrastructureByYear } from '../utils';

export const useFutureTypes = (
  infrastructureMapByYearRef: React.MutableRefObject<Map<number, IInfrastructureData>>,
): [(TRegularInfrastructureType | TFutureRoad)[], (year: number | null) => void] => {
  const [futureTypes, setFutureTypesState] = React.useState<(TRegularInfrastructureType | TFutureRoad)[]>([]);

  const setFutureTypes = React.useCallback(
    (selectedYear: number | null) => {
      if (!selectedYear) {
        setFutureTypesState([]);

        return;
      }

      const { futureTypes } = getInfrastructureByYear(infrastructureMapByYearRef.current, selectedYear);

      setFutureTypesState(futureTypes);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [infrastructureMapByYearRef, infrastructureMapByYearRef.current],
  );

  return [futureTypes, setFutureTypes];
};
